"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redactRequestProperty = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
/**
 * Redact any value that appears with the property name "request". Picks out specific values and returns only those
 * in order to avoid logging too much. Also has perf benefits as we avoid recursively redacting the entire request
 * object.
 */
var redactRequestProperty = exports.redactRequestProperty = {
  // Handle request being included in errors.
  test: function test(propertyName, value) {
    return propertyName === 'request' && (0, _typeof2.default)(value) === 'object' && value !== null;
  },
  replacement: function replacement(value) {
    return {
      uri: value.uri,
      method: value.method,
      headers: {
        'X-Caller-Client-ID': value.headers && value.headers['X-Caller-Client-ID']
      }
    };
  }
};